import React from 'react'
import moment from "moment";
import { component_tool } from '@/tool'
let { WizModal } = component_tool
import { WizClassifySelect,WizClassifySelectRe,WizTableForm } from '@/containers/common';
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1 } })
//配置项
let componentName = 'comment'
let ref;

const columns = (commentData) => {
  let commentTypeSelect = commentData && commentData.bizType && commentData.bizType == 36 ? 'hidden' :'select'
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },

    {
      name: "createBy",
      formItem: {
        type: "hidden",
      }
    },
    {
      name: "createTime",
      formItem: {
        type: "hidden",
      }
    },

    {
      title: "评论内容",
      name: "content",
      dataIndex: "content",
      searchItem: {},
      tableItem: {}
    },
    // {
    //   title: "关联实体类型",
    //   name: "bizType",
    //   dataIndex: "bizType",
    //   dict: [
    //     { code: 1, codeName: "考试" },
    //     { code: 20, codeName: "内容" },
    //     { code: 24, codeName: "帖子" }
    //   ],
    //   tableItem: {
    //     width: 100,
    //   },
    // },
    {
      title: "评论人",
      name: "commentPerson",
      dataIndex: "commentPerson",
      searchItem: {

      ...userConfig,
      diy: WizTableForm,
      },
      tableItem: {}
    },

    {
      title: '评论时间',
      name: 'commentTime',
      dataIndex: 'commentTime',
      tableItem: {},
      searchItem: {
        type: 'date~',
        showTime: true,
      },
    },
    {
      title: "关联实体类型",
      name: "bizType",
      dataIndex: "bizType",
      tableItem: {},
      dict: [
        { code: 0, codeName: "课程" },
        { code: 1, codeName: "考试" },
        { code: 16, codeName: "评语" },
        { code: 20, codeName: "内容" },
        { code: 24, codeName: "帖子" },
        { code: 35, codeName: "评论" },
        { code: 36, codeName: "班级" },
      ],
      searchItem: {
        type: "select",
        formatInit: () => commentData.bizType,
        disabled: commentData?.bizType === 36,
        initialValue: commentData.bizType
      },
    },
     {
      title: '关联实体',
      name: 'bizId',
      searchItem: {
        formatInit: () => commentData.bizId,
        type: 'diy',
        links: { 'bizType': '业务类型' },
        ...WizTableForm.Config.program(this, {}),
        changePopsFunction: (
          linksValues
        ) => {
          if(commentData.bizType === 36 && commentData.bizId) {
            return {disabled: true}
          }
          const { bizType } = linksValues
          let config;
          if (bizType === 20) {
            config = WizTableForm.Config.content()
          } else if (bizType === 1) {
            config = WizTableForm.Config.exam()
          } else if (bizType === 24) {
            config = WizTableForm.Config.invitation()
          } else if (bizType === 36) {
            config = WizTableForm.Config.classInfoAll()
          } else if(bizType === 0) {
            config = WizTableForm.Config.program()
          } else {
            config = null
          }
          if(!config) {
            config = {disabled: true}
          }
          return config
        },
        diy: WizTableForm,
        initialValue: commentData.bizId,
        initRows: commentData.bizEntity ? commentData.bizEntity : []
      },

    },
    {
      title: "评论类型",
      name: "commentType",
      dataIndex: "commentType",
      dict: [
        { code: 0, codeName: "评论" },
        { code: 1, codeName: "回复评论" },
      ],
      searchItem: {
        type: commentTypeSelect
      },
      tableItem: {
        width: 100,
      },
    },

    {
      title: "是否置顶",
      name: "switchTop",
      dataIndex: "switchTop",
      dict: [
        { code: 0, codeName: "否" },
        { code: 1, codeName: "是" },
      ],
      searchItem: {
        type: "select"
      },
      tableItem: {
        width: 100,
      },
    },
    {
      title: "是否屏蔽",
      name: "switchScreen",
      dataIndex: "switchScreen",
      dict: [
        { code: 0, codeName: "否" },
        { code: 1, codeName: "是" },
      ],
      searchItem: {
        type: "select"
      },
      tableItem: {
        width: 100,
      },
    },
    {
      title: "被回复的评论人",
      name: "replyPerson",
      dataIndex: "replyPerson",
      tableItem: {}
    },
]
}
  ;

const templateConfig = (data) => {
   const { commentData,btnAccessCheck } = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(commentData),
        btnAccessCheck: btnAccessCheck,
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign([], v)
            value['bizType'] = value['bizType'] == 0 ? '0' :value['bizType'];
            if (value['commentTime'] && value['commentTime'].length === 2) {
              value['commentTimeStart'] = moment(value['commentTime'][0]).format("YYYY-MM-DD HH:mm:00")
              value['commentTimeEnd'] = moment(value['commentTime'][1]).format("YYYY-MM-DD HH:mm:00")
            }
            console.log('value', value);
            return value
          },
        },
        // siderBarProps: {
        //   key: "nodeTree",
        //   searchKey: "typeIds",
        //   params: { type: 5 }
        // },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['topOrCancelTop', 'shieldOrUnshield'],
        commonOperate: {
          add: true,
          update: true,
          delete: true,
          look: false
        },
        rowOperateView: [

        {
          key: "topOrCancelTop",
          custom: true,
          params: {children: "置顶"},
          textFormat: {
            recordKey: 'switchTop',
            dirt: {'1': '取消置顶', '0': '置顶',}
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "changeTop",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['switchTop'] === 0 ? "置顶" : "取消置顶"
              }该评论吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    id: record['id'],
                    ...filters
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "shieldOrUnshield",
          custom: true,
          params: {children: "屏蔽"},
          textFormat: {
            recordKey: 'switchScreen',
            dirt: {'1': '取消屏蔽', '0': '屏蔽',}
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "changeScreen",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['status'] === 0 ? "启用" : "禁用"
              }该评论吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    id: record['id'],
                    ...filters
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        }
        ]
      }
    }
  }
};


const apis = (commentData) => {
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {pageNum: 1, pageSize: 10, bizType: commentData.bizType, bizId: commentData.bizId}
      }
    },
    changeTop: {
      path: `${componentName}/changeTop`,
      payload: {
        key: `${componentName}@changeTop`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {bizType: commentData.bizType, bizId: commentData.bizId}
      }
    },
    changeScreen: {
      path: `${componentName}/changeScreen`,
      payload: {
        key: `${componentName}@changeScreen`,
        apiParams: {}
      }
    }
  };
}

let reduxTemplateCofig = (args) => {
  let {commentData} = args
  return {
    apis: apis(commentData),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
